import CommonLayer from '@/components/common/CommonLayer.vue';

export default {
  install(Vue) {
    const Layer = Vue.extend(CommonLayer);
    const layerDiv = document.createElement('div');
    const $vm = new Layer({
      el: layerDiv
    });
    Vue.prototype.$layer = {
      alert(opt) {
        $vm.titleCode = 0;
        $vm.defaultInfoCode = -1;
        $vm.options.msg = opt.msg;
        $vm.showLayer();
      },
      warn(opt) {
        $vm.titleCode = 1;
        $vm.defaultInfoCode = -1;
        $vm.options = opt;
        $vm.showLayer();
      },
      confirm(opt) {
        $vm.titleCode = 2;
        $vm.defaultInfoCode = -1;
        $vm.options = opt;
        $vm.showLayer();
      },
      success() {
        $vm.titleCode = 0;
        $vm.defaultInfoCode = 0;
        $vm.showLayer();
      },
      failed() {
        $vm.titleCode = 0;
        $vm.defaultInfoCode = 1;
        $vm.showLayer();
      }
    };
  }
};
